import { Radio } from "antd";
import { theme } from "src/theme/theme";
import styled from "styled-components";
import { colors } from "src/theme/colors";
import { line, radii } from "src/theme/ui";

/**
 * The order type, as the product's segmented control.
 *
 * `buttonStyle="solid"` filled the chosen half with the accent at full
 * strength — a blue slab across half a dialog, which made the choice of order
 * type the loudest thing on a screen whose subject is a trade. In this design
 * a solid accent fill is reserved for the one action a screen is FOR, and
 * that is the button at the bottom. A chosen segment is marked, not filled.
 */
export const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;

  .ant-radio-button-wrapper {
    flex: 1 !important;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
    border: 1px solid ${line.field};
    border-radius: ${radii.control}px;
    background: ${colors.white};
    font-size: 13px;
    font-weight: 500;
    color: ${colors.gray[700]};
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  }

  /* Ant Design draws a divider between adjacent segments out of a
     pseudo-element; with a gap between them there is nothing to divide. */
  .ant-radio-button-wrapper::before {
    display: none !important;
  }

  .ant-radio-button-wrapper:first-child {
    border-radius: ${radii.control}px;
  }

  .ant-radio-button-wrapper:hover {
    border-color: ${colors.gray[300]};
    color: ${colors.gray[900]};
  }

  &.ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: ${colors.primary[200]};
    background: ${colors.primary[15]};
    color: ${colors.primary[600]};
    font-weight: 600;
  }

  &.ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):hover {
    border-color: ${colors.primary[300]};
    background: ${colors.primary[15]};
    color: ${colors.primary[600]};
  }
`;

export const RadioGroupTif = styled(Radio.Group)`
  // display: flex;
  // flex-wrap: wrap;
  // .ant-radio-button-wrapper {
  //     text-align: center;
  //     flex: 1 !important;
  //     white-space: nowrap;
  // }
`;

export const RadioGroupPL = styled(Radio.Group)`
  & .ant-radio-button-wrapper {
    border: none;
    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  }
  &
    .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):focus-within {
    box-shadow: none;
  }
`;
